/**
 * Constants and types for {@link ApryseRendererComponent}.
 */

/** Zoom floor mirrors the instance's `setMinZoomLevel(1)`; ceiling caps run-away zoom. */
export const MIN_ZOOM_PCT = 100;
export const MAX_ZOOM_PCT = 800;
/** Multiplicative zoom step — ×1.25 in, ÷1.25 out. */
export const ZOOM_STEP = 1.25;

// Brand search-highlight colors. The Apryse API takes raw CSS colors (not SCSS tokens), so these
// mirror the design-system primary palette: all matches → primary-700 (#55abb7), active match →
// primary-500 (#0d8899). Translucent so the underlying glyphs stay readable.
export const SEARCH_HIGHLIGHT_COLOR = 'rgba(85, 171, 183, 0.5)';
export const ACTIVE_SEARCH_HIGHLIGHT_COLOR = 'rgba(13, 136, 153, 0.5)';

/** Minimal shape of the Apryse search result we depend on. */
export interface ApryseSearchResult {
  resultCode: number;
}

/**
 * Native WebViewer header + page-navigation chrome that conflicts with our own floating controls
 * (FilePreviewControlsComponent). Disabled on the shared instance at acquire and re-enabled on
 * release — the recycled WebViewer singleton also serves the signing flows, whose chrome
 * expectations must survive a preview session. Lives here (not in webviewer.config) so the
 * app-wide Apryse setup stays untouched by the previewer.
 * Covers both legacy and modular-UI header names plus the native page-navigation overlay.
 */
export const NATIVE_CHROME_ELEMENTS = [
  'header',
  'default-top-header',
  'tools-header',
  'view-controls',
  'pageNavOverlay',
  'page-controls-container',
  'page-controls',
];
